let API_URL;
if ((!process.env.NODE_ENV || process.env.NODE_ENV === 'development') && localStorage.getItem('productionInDevelopment') !== 'true') {
    API_URL = 'http://localhost:8000';
} else {
    API_URL = 'https://apiv2.pindrop.it/v3';
}

export { API_URL };
